import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useEditEnquiry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }) => {
      const res = await api.put(`/enquiry/${id}`, body);
      return res.data;
    },
    onSuccess: async (_, { id }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["enquiryList"] }),
        queryClient.invalidateQueries({ queryKey: ["enquiry", id] }),
      ]);
    },
  });
};
